import React from "react";
import { useGetAdminImpactCoverageQuery } from "../../api/respectCardsApi";

/**
 * Phase 2b cards-launch — Links + impact coverage tab.
 */

const card: React.CSSProperties = {
  background: "#fff",
  padding: 16,
  borderRadius: 8,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
  marginBottom: 16,
};

const linkCard: React.CSSProperties = {
  display: "block",
  padding: 16,
  border: "1px solid #c7c1e0",
  borderRadius: 8,
  background: "#faf7ff",
  color: "#3730a3",
  textDecoration: "none",
  fontWeight: 600,
  marginBottom: 8,
};

const missingChip: React.CSSProperties = {
  display: "inline-block",
  fontSize: "0.75rem",
  fontWeight: 600,
  padding: "3px 10px",
  borderRadius: 999,
  marginRight: 6,
  marginBottom: 6,
  background: "#fee2e2",
  color: "#991b1b",
};

const LinksTab: React.FC = () => {
  const { data, isLoading, error } = useGetAdminImpactCoverageQuery();

  return (
    <>
      <section style={card}>
        <h2 style={{ fontSize: "1.1rem", color: "#333", marginBottom: 12 }}>
          Quick links
        </h2>
        <a
          href="/admin/cards?tab=runtime"
          style={linkCard}
        >
          → Active effects (admin)
        </a>
        <a
          href="/admin/cards?tab=runtime"
          style={linkCard}
        >
          → Card audit log
        </a>
      </section>

      <section style={card}>
        <h2 style={{ fontSize: "1.1rem", color: "#333", marginBottom: 12 }}>
          Coverage report
        </h2>
        {isLoading ? (
          <p style={{ color: "#666" }}>checking impact coverage…</p>
        ) : error ? (
          <p style={{ color: "#a00" }}>failed to load coverage report.</p>
        ) : !data ? null : data.missing.length === 0 ? (
          <p style={{ color: "#166534" }}>
            All effect types documented ✅ ({data.documented}/{data.totalReferencedTypes})
          </p>
        ) : (
          <div>
            <p style={{ fontSize: "0.85rem", color: "#444", marginBottom: 8 }}>
              {data.documented}/{data.totalReferencedTypes} documented — missing impact
              docs for these effect types:
            </p>
            <div>
              {data.missing.map((key) => (
                <span key={key} style={missingChip}>
                  {key}
                </span>
              ))}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default LinksTab;
